import { Vue } from 'vue-class-component';

import PlaylistItems from '../playlist-items/playlist-items';

import { Media$Type, Media$Details } from '@/types/Media';

const CN = 'playlist-videos';

class Props {
  origin!: Media$Details;
}

export default class PlaylistVideos extends Vue.with(Props) {
  render() {
    return (
      <PlaylistItems
        class={CN}
        mediaType={Media$Type.VIDEO}
        origin={this.origin}
        {...this.$attrs}
      />
    );
  }
}
